module.exports = __webpack_public_path__ + "static/accreditations7-5d96f47968b4d72d274564315355c2af.png";